// extracted by mini-css-extract-plugin
export default {"Subheading":"FYW6_qBP"};